// The ticker/tickerGroup props the editor sends with every preview and publish
// (downloadPDF → /previewv2, /publishv2, /publishv2/override).
//
// tickerGroup is the DOCUMENT KEY on the backend: CraigsPublishingService keys
// published_document.ticker off it and locks the version snapshot under
// "<tickerGroup>/<template>". For scheme templates it must therefore be the
// OFFER NUMBER (OFR…) — the same key updateTickerGroup, the editor URL params,
// and /server-publish use — NOT the scheme's display name (offerName), which
// keyed editor publishes of scheme docs under "Simplicity KiwiSaver Scheme"
// and orphaned them from their library row, compare dropdowns, and locked
// snapshots (2026-08-05 Simplicity run, risk 3 — affected BOTH the round
// Publish and Publish Without Review, since both build props here).

//MAP OF ALL TEMPLATE TICKER TYPES
export const TEMPLATE_TICKER_TYPES = {
	SELECTION: "selection",
	OPEN: "open",
	FIXED: "fixed",
	SCHEME: 'scheme',
	FUND: 'fund',
	BRAND: 'brand',
	SCHEME_SELECTION: 'scheme-selection'
}

/**
 * Pure builder for the preview/publish props — extracted from
 * EditorSideBarExtension.downloadProps so the key choice stays pinned by tests.
 *
 * @param state { template, selectedTickerGroup, tickers, selectedTemplate }
 */
export function buildPublishTickerProps({ template, selectedTickerGroup, tickers, selectedTemplate }) {
	const props = {
		tickers: tickers,
		template: selectedTemplate
	}
	if (template.ticker.type === TEMPLATE_TICKER_TYPES.SELECTION) {
		props.tickerGroup = selectedTickerGroup?.name;
	}
	if (template.ticker.type === TEMPLATE_TICKER_TYPES.SCHEME || template.ticker.type === TEMPLATE_TICKER_TYPES.SCHEME_SELECTION) {
		props.tickerGroup = selectedTickerGroup?.offerNumber;
	}
	if (template.ticker.type === TEMPLATE_TICKER_TYPES.FIXED) {
		if (props.tickers[0] === '' || props.tickers[0] === undefined) {
			props.tickers[0] = template.ticker.ticker
		}
	}
	return props;
}
